import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Api } from '../api/api';
import { UserAuth } from '../../models/user.model';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import { GlobalNotificationsProvider } from '../global-notifications/global-notifications';
import 'rxjs/add/observable/interval';
import { WebSocketProvider } from './../../providers/web-socket/web-socket';
import { IntervalServiceProvider } from './../interval-service/interval-service';
import { GeoFenceProvider } from './../geo-fence/geo-fence';
import { map } from 'rxjs/operators';
import { EventInfoProvider } from '../event-info/event-info';

@Injectable()
export class User {
    //private isLoggedIn = false;
    user: UserAuth;
    interval: any;

    constructor(
        public socketProvider: WebSocketProvider,
        public api: Api,
        public storage: Storage,
        private globalNotifications: GlobalNotificationsProvider,
        private intervalServiceProvider: IntervalServiceProvider,
        private geofenceProdiver: GeoFenceProvider,
        private eventInfoProvider: EventInfoProvider
    ) { }

    /**
     * Send a POST request to our login endpoint with the data
     * the user entered on the form.
     */
    login(accountInfo: any) {
        let seq = this.api.postLogin('sessions/login', accountInfo).share();

        seq.subscribe(
            (res: any) => {
                // If the API returned a successful response, mark the user as logged in
                if (res.sessionId) {
                    this.loggedIn(res);
                    this.getCurrentUser(res.sessionId).subscribe(currentUser => {
                        this.setCurrentUser(currentUser);
                    });
                }
            },
            err => {
                console.error('ERROR', err);
            }
        );

        return seq;
    }

    verifyEmail(verificationNumber: any) {
        let seq = this.api.postLogin('user/verify/verifyAccount', { verificationNumber: verificationNumber }).share();

        seq.subscribe(
            (response: any) => {

            },
            err => {
                console.error('ERROR', err);
            }
        );

        return seq;
    }

  verifyNewEmail(verificationNumber: any) {
          let seq = this.api.postLogin('user/verify/verifyNewEmail', { verificationNumber: verificationNumber }).share();

          seq.subscribe(
              (response: any) => {

              },
              err => {
                  console.error('ERROR', err);
              }
          );

          return seq;
  }

    resendVerificationEmail(email: any) {
        let seq = this.api.postLogin('user/verify/resendVerificationCode', { email: email }).share();

        seq.subscribe(
            (response: any) => {

            },
            err => {
                console.error('ERROR', err);
            }
        );

        return seq;
    }


    sendVerificationNewEmail(emailOld: any, emailNew: any) {
        let seq = this.api.postLogin('user/verify/sendVerificationCode', { oldEmail: emailOld, newEmail: emailNew }).share();

        seq.subscribe(
            (response: any) => {

            },
            err => {
                console.error('ERROR', err);
            }
        );

        return seq;
    }
    /**
     * Send a POST request to our signup endpoint with the data
     * the user entered on the form.
     */
    signup(accountInfo: any) {
        let seq = this.api.postLogin('user/create', accountInfo).share();

        seq.subscribe(
            (res: any) => {
                // If the API returned a successful response, mark the user as logged in
                if (res.status == 'success') {
                    //this.loggedIn(res);
                }
            },
            err => {
                console.error('ERROR', err);
            }
        );

        return seq;
    }

    signUpWithLinkedinAccessToken(accessToken: string, expiresOn: string): Observable<any> {
        return this.api.post('sessions/create/linkedin', {
            accessToken: accessToken,
            expiresOn: expiresOn,
        }).map((res: any) => {
            this.loggedIn(res);
            this.getCurrentUser(res.sessionId).subscribe(currentUser => {
                this.setCurrentUser(currentUser);
                return this.getCurrentUser();
            });
        });
    }
// Uncoment if we ever want to return facebook
//     signUpWithFacebookAccessToken(accessToken: string, expiresOn: any): Observable<any> {
//         return this.api.post('sessions/create/facebook', {
//             accessToken: accessToken,
//             expiresOn: expiresOn,
//         }).map((res: any) => {
//             this.loggedIn(res);
//             this.getCurrentUser(res.sessionId).subscribe(currentUser => {
//                 this.setCurrentUser(currentUser);
//                 return this.getCurrentUser();
//             });
//         });
//     }

    signUpWithApple(data: any) {
      const body = {
        externalId: "2s3",
        email: data.email || "email",
        provider: "APPLE",
        name: data.fullName.givenName,
        firstName: data.fullName.givenName,
        lastName: data.fullName.familyName,
        accessToken: data.identityToken,
        user: data.user
      }

      return this.api.post('sessions/appleLogin', { ...body }).map((res: any) => {
        this.loggedIn(res);
        this.getCurrentUser(res.sessionId).subscribe(currentUser => {
            this.setCurrentUser(currentUser);
            return this.getCurrentUser();
        });
      });
    }

    storeDeviceToken(token: string): Observable<any> {
        return this.api.post("user/assignDeviceToken", {
            token: token
        }, {
                responseType: 'text',
            }).map((res: any) => res);
    }

    /**
     * Log the user out, which forgets the session
     */
    logout(): Observable<any> {
        // const user = localStorage.getItem('user');
        // const sessionId = user ? user.substring(1, user.length-1) : null;
        return this.api.get('sessions/logout', {}).map(res => {
            this.user = null;
            localStorage.clear();
            // disable global notifications service

            this.intervalServiceProvider.clearInterval();

            return res;
        });
    }

    /**
     * Process a login/signup response to store user data
     */
    loggedIn(resp) {
        localStorage.setItem('user', JSON.stringify(resp.sessionId));
    }

    // Returns whether the user is currently authenticated
    // Could check if current token is still valid
    //Napraviti servis koji ce da aktivira socket u
    async authenticated(): Promise<any> {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            this.intervalServiceProvider.clearInterval();
            this.user = user;
            // this.geofenceProdiver.readAndSendLocation();
            // this.geofenceProdiver.sendLcoationIntervalInit();
            this.geofenceProdiver.watchAndSend();
            this.intervalServiceProvider.intervalInit();
            return true;
        }
        this.intervalServiceProvider.clearInterval();
        this.geofenceProdiver.clearWatch();
        return false;
    }

    getEmailExist(email: string): Observable<any> {
        return this.api
            .getNoSession('sessions/findByEmail', { email: email })
            .map(res => {
                return res;
            });
    }

    uploadProfile(image: any): Observable<any> {
        return Observable.fromPromise(
            this.api.fileUpload('user/upload/images', image)
        ).mergeMap(res => {
            return res;
        });
    }

    getCurrentUser(sessionId?: string): Observable<any> {
        if (sessionId) {
            let reqOpts = {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + sessionId,
                }),
            };
            //Dodao Bearer refaktorisati kasnije
            return this.api.postLogin(
                'user/loadCurrentUser',
                { sessionId: sessionId },
                reqOpts
            );
        }
    }

    currentUser() {
        const user = JSON.parse(localStorage.getItem('currentUser'));
        return user;
    }

    providerLogin(body: any): Observable<any> {
        return this.api.postLogin('sessions/providerLogin', body);
    }

    setIndexDb(key, value): void {
        this.storage.set(key, value);
    }

    setCurrentUser(user) {
        localStorage.setItem('currentUser', JSON.stringify(user));
    }

    loadCurrentUser(): Observable<any> {
        return this.api.post('user/loadCurrentUser', {}).pipe(
            map(res => {
                return res;
            })
        );
    }

    getIndexDb(value) {
        return this.storage.get(value);
    }

}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts